import { cn } from "@/lib/utils";
import { Link } from "react-router-dom";

export const TCSLink = (
  { linkTo, linkText, className }: { linkTo: string, linkText: string, className?: string }
) => {
  return (
    <Link
      to={linkTo}
      className={cn("text-sm text-accent underline font-semibold", className)}
    >
      {linkText}
    </Link>
  );
};
